import { HttpClientModule } from '@angular/common/http';
import { CategoriasService } from '../../../services/categorias.service';
import { TokenService } from '../../../services/token.service';
import { FormGroup, FormBuilder, Validators, FormArray, RequiredValidator } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { TranslatePipe } from '../../../pipes/translate.pipe';

@Component({
  selector: 'app-segmento-superior',
  templateUrl: './segmento-superior.component.html',
  styleUrls: ['./segmento-superior.component.css']
})
export class SegmentoSuperiorComponent implements OnInit {
  isSubmitted = false;
  @Output() mudaItems = new EventEmitter();
  segmentoForm: FormGroup;
  idSegmento: string;
  url = null;
  user = this.tokenService.GetPayLoad();
  teste = this.tokenService.GetPayLoad();
  modoEdicao = false;
  produtoSubmitted = false;
  uploadImage = false;
  image: any;
  imageId: string;
  imageUrl: string;
  imageSecureUrl: string;
  marcas: any;
  produtos: any;
  moedasCombo: any;
  produtosInclusos = [];
  produtosQuantidade = [];
  moedasSelecionadas = [];

  constructor(
    private translatePipe: TranslatePipe,
    private fb: FormBuilder,
    private categoriasService: CategoriasService,
    private tokenService: TokenService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.init();

    this.route.paramMap.subscribe(params => {
      this.idSegmento = params.get('idSegmento');

      if (this.idSegmento) {
        this.modoEdicao = true;
        this.carregaCampos();
      }
    });

  }

  init() {
    this.segmentoForm = this.fb.group({
      nomeItem: ['', Validators.required],
    });
  }

  getImage(event) {
    this.image = event;
  }

  onSubmit(form: FormGroup) {
    this.isSubmitted = true;
    if (form.valid && (this.image || this.imageId)) {

      if (this.image) {
        this.categoriasService.uploadImages(this.image).subscribe(res => {
          this.salvar({
            name: this.segmentoForm.value.nomeItem,
            belongs_to: 'Top',
            image: {
              id: res.public_id,
              url: res.url,
              secure_url: res.secure_url
            }
          });
        });
      }
      else {
        this.salvar({
          name: this.segmentoForm.value.nomeItem,
          belongs_to: 'Top',
          image: {
            id: this.imageId,
            url: this.imageUrl,
            secure_url: this.imageSecureUrl
          }
        });
      }
    }
  }

  salvar(segmento) {
    if (this.idSegmento) {
      this.categoriasService.editarCategoriaItem(this.idSegmento, segmento).subscribe(
        res => {
          Swal.fire(this.translatePipe.transform('gerenciamento_segmentos_superior'), this.translatePipe.transform('gerenciamento_segmentos_superior_editado'), 'success').then(() => {
            this.router.navigate([`admin/segmentos-superiores`]);
          });
        },
        error => {
          Swal.fire(this.translatePipe.transform('gerenciamento_segmentos_superior'), error.error.message, 'error');
        }
      );
    } else {
      this.categoriasService.salvaCategoria(segmento).subscribe(
        res => {
          Swal.fire(this.translatePipe.transform('gerenciamento_segmentos_superior'), this.translatePipe.transform('gerenciamento_segmentos_superior_cadastrado'), 'success').then(() => {
            this.router.navigate([`admin/segmentos-superiores`]);
          });
        },
        error => {
          Swal.fire(this.translatePipe.transform('gerenciamento_segmentos_superior'), error.error.message, 'error');
        }
      );
    }
  }

  cancelar() {
    this.router.navigate([`admin/segmentos-superiores`]);
  }

  // Editar
  carregaCampos() {
    this.isSubmitted = true;
    this.categoriasService.obterCategoria(this.idSegmento).subscribe(res => {
      this.segmentoForm.controls.nomeItem.setValue(res.name);

      this.imageId = res.image?.id;
      this.imageUrl = res.image?.url;
      this.imageSecureUrl = res.image?.secure_url;
      this.url = res.image.url;
    });
    this.segmentoForm.updateValueAndValidity();
  }
}
